import { IEventParticipant } from '@azavista/planner-lib';
import * as TRANSLATIONS from '../../assets/i18n/en-US.json';
import { IVersionInfo } from '../print-server-api/interfaces';
import { ImageObject } from './interfaces';

export type TranslationMapKey = keyof typeof TRANSLATIONS;
export type TranslationMap = { [Key in TranslationMapKey]: Key };
export const TRANSLATION_MAP: TranslationMap = Object.keys(TRANSLATIONS).reduce((record, key) => ({
    ...record,
    [key]: key
}), {} as TranslationMap);

export const LOGO: ImageObject = {
    url: 'assets/images/Azavista-color.svg',
    alt: 'logo'
};

export const MIN_PRINT_SERVER_VERSION: IVersionInfo = {
    version: '1.0.7',
    major: 1,
    minor: 0,
    patch: 7
};

export const DEFAULT_PRINT_SERVER_PORT = 9001;
export const MOCK_EVENT_PARTICIPANT = {
    first_name: 'John',
    last_name: 'Smith',
    email: 'john.smith@mail.com',
    id: 'somerandomID'
} as IEventParticipant;

export const DEFAULT_DPI_OPTIONS = [203, 300, 600];

export const FIELD_NAME_VIRTUAL_ORGANIZATION_NAME = '__organization_name';
export type IEventParticipantWithCompanyName = IEventParticipant & {
    [organization_name in typeof FIELD_NAME_VIRTUAL_ORGANIZATION_NAME]?: string
}
